import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-menu",
  "use": "icon-menu-usage",
  "viewBox": "0 0 30 30",
  "content": "<symbol fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 30 30\" id=\"icon-menu\"><path d=\"M1.25 10.625h27.5m-27.5 8.75h27.5\" stroke=\"currentColor\" stroke-width=\"1.875\" stroke-linecap=\"square\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol